import authentication from '@/store/usermanagement/authentication';
import user from '@/store/usermanagement/user';
import Vue from 'vue';
import { Dispatch } from 'vuex';

export default {
	namespaced: true,
	modules: {
		authentication,
		user,
	},
	actions: {
		async fetchGlobalUser({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await dispatch('authentication/fetchGlobalAuthentication');
			await dispatch('user/fetchUser', { id: Vue.$cookies.get('Global-Token').id });
		},

		async fetchUser({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await dispatch('authentication/fetchAuthentication');
			await dispatch('user/fetchUser', { id: Vue.$cookies.get('Token').id });
		},

		cleanFullUser({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('user/cleanUser');
			dispatch('authentication/deleteAuthentication');
		},
	},
};
